<div class="container bg-header" style="background-color: rgb(105, 69, 175) !important;">
  <div class="row">
    <div class="col-8">
      <h1 mat-dialog-title class="text-white p-3 m-0" style="color: white !important;">
        {{ 'modals.select-inputs.title' | translate }}
      </h1>
    </div>
    <div class="col-4 d-flex justify-content-end align-items-center">
      <p role="button" (click)="closeModal()" class="text-white m-0">{{ 'generic.buttons.cancel' | translate }}</p>
      <mat-icon class="ml-1" (click)="closeModal()">cancel</mat-icon>
    </div>
  </div>
</div>

<div mat-dialog-content class="m-3">
  <div class="container">
    <!-- Selected Inputs Summary -->
    <div class="row mb-3">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
          <span class="badge badge-info">
            {{ selectedInputs.length }}
            {{ selectedInputs.length === 1 ? ('modals.select-inputs.input-selected' | translate) : ('modals.select-inputs.inputs-selected' | translate) }}
          </span>
        </div>
      </div>
    </div>

    <!-- Input Type Tabs -->
    <div class="row">
      <div class="col-12">
        <mat-tab-group [(selectedIndex)]="activeTabIndex" (selectedTabChange)="onTabChange($event)">

          <!-- SURVEY TAB -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="mr-2">poll</mat-icon>
              {{ 'modals.select-inputs.tabs.surveys' | translate }}
            </ng-template>

            <div class="tab-content p-3">
              <div *ngIf="loadingSurveys" class="text-center py-4">
                <mat-spinner diameter="40"></mat-spinner>
                <p class="mt-2">{{ 'generic.loading' | translate }}</p>
              </div>

              <div *ngIf="!loadingSurveys && availableSurveys.length === 0" class="text-center py-4">
                <mat-icon style="font-size: 3rem; color: #ccc;">poll</mat-icon>
                <p class="text-muted mt-2">{{ 'modals.select-inputs.no-surveys' | translate }}</p>
              </div>

              <div *ngIf="!loadingSurveys && availableSurveys.length > 0">
                <div *ngFor="let survey of availableSurveys"
                     class="input-item"
                     [class.selected]="selectedSurveys.has(survey.id)"
                     (click)="toggleSurveySelection(survey.id)">
                  <mat-checkbox [checked]="selectedSurveys.has(survey.id)" (click)="$event.stopPropagation()"></mat-checkbox>
                  <mat-icon class="mx-2">poll</mat-icon>
                  <div class="flex-grow-1">
                    <div class="input-name">{{ survey.title }}</div>
                    <div class="input-meta">
                      <span *ngIf="survey.members">{{ survey.members.length }} {{ 'modals.select-inputs.participants' | translate }}</span>
                      <span class="ml-2" *ngIf="survey.questions_count">{{ survey.questions_count }} {{ 'modals.select-inputs.questions' | translate }}</span>
                      <span class="badge ml-2" [ngClass]="getCompletionBadgeClass(survey)">
                        {{ getCompletionPercentage(survey) }}% {{ 'modals.select-inputs.completion' | translate }}
                      </span>
                      <span class="ml-2 text-muted">{{ survey.updated_at | date:'dd/MM/yyyy' }}</span>
                    </div>
                  </div>
                  <button mat-icon-button (click)="viewSurveyDetails(survey.id, $event)" class="ml-2">
                    <mat-icon>visibility</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </mat-tab>

          <!-- PDF TAB -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="mr-2">picture_as_pdf</mat-icon>
              {{ 'modals.select-inputs.tabs.pdf' | translate }}
            </ng-template>

            <div class="tab-content p-3">
              <div class="mb-3">
                <input type="file"
                       #fileInput
                       accept="application/pdf"
                       multiple
                       style="display: none"
                       (change)="onFileSelected($event)">
                <button mat-raised-button color="primary" (click)="fileInput.click()" [disabled]="uploadingPDF">
                  <mat-icon>upload</mat-icon>
                  {{ 'modals.select-inputs.upload-pdf' | translate }}
                </button>
              </div>

              <div *ngIf="uploadingPDF" class="mb-3">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                <p class="text-center mt-2">{{ 'modals.select-inputs.uploading' | translate }}</p>
              </div>

              <!-- Loading state -->
              <div *ngIf="loadingPDFs" class="text-center py-4">
                <mat-spinner diameter="40"></mat-spinner>
                <p class="mt-2">{{ 'generic.loading' | translate }}</p>
              </div>

              <!-- Stored PDFs from database -->
              <div *ngIf="!loadingPDFs && storedPDFs.length > 0">
                <h4 class="mb-3">{{ 'modals.select-inputs.stored-pdfs' | translate }}</h4>
                <div *ngFor="let pdf of storedPDFs"
                     class="input-item"
                     [class.selected]="selectedPDFs.has(pdf.id)"
                     (click)="toggleStoredPDFSelection(pdf.id)">
                  <mat-checkbox [checked]="selectedPDFs.has(pdf.id)" (click)="$event.stopPropagation()"></mat-checkbox>
                  <mat-icon class="mx-2 text-danger">picture_as_pdf</mat-icon>
                  <div class="flex-grow-1">
                    <div class="input-name">{{ pdf.file_name }}</div>
                    <div class="input-meta">
                      <span>{{ formatFileSize(pdf.file_size) }}</span>
                      <span class="ml-2 text-muted" *ngIf="pdf.pages_count">{{ pdf.pages_count }} {{ 'modals.select-inputs.pages' | translate }}</span>
                      <span class="ml-2 text-muted">{{ pdf.upload_date | date:'dd/MM/yyyy' }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Newly uploaded PDFs -->
              <div *ngIf="uploadedPDFs.length > 0" class="mt-3">
                <h4 class="mb-3">{{ 'modals.select-inputs.newly-uploaded' | translate }}</h4>
                <div *ngFor="let pdf of uploadedPDFs; let i = index" class="input-item selected">
                  <mat-icon class="mx-2 text-danger">picture_as_pdf</mat-icon>
                  <div class="flex-grow-1">
                    <div class="input-name">{{ pdf.name }}</div>
                    <div class="input-meta">{{ pdf.metadata?.size }}</div>
                  </div>
                  <button mat-icon-button (click)="removePDF(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>

              <!-- Empty state -->
              <div *ngIf="!loadingPDFs && storedPDFs.length === 0 && uploadedPDFs.length === 0 && !uploadingPDF" class="text-center py-4">
                <mat-icon style="font-size: 3rem; color: #ccc;">picture_as_pdf</mat-icon>
                <p class="text-muted mt-2">{{ 'modals.select-inputs.no-pdfs' | translate }}</p>
              </div>
            </div>
          </mat-tab>

          <!-- PUBMED TAB -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="mr-2">article</mat-icon>
              {{ 'modals.select-inputs.tabs.pubmed' | translate }}
            </ng-template>

            <div class="tab-content p-3">
              <!-- Add PubMed Article Button -->
              <div class="mb-3">
                <button mat-raised-button color="primary" (click)="openPubMedAttachmentModal()">
                  <mat-icon>add</mat-icon>
                  {{ 'modals.select-inputs.add-pubmed-article' | translate }}
                </button>
              </div>

              <!-- Loading state -->
              <div *ngIf="loadingPubMedDocs" class="text-center py-4">
                <mat-spinner diameter="40"></mat-spinner>
                <p class="mt-2">{{ 'generic.loading' | translate }}</p>
              </div>

              <!-- Stored PubMed documents from database -->
              <div *ngIf="!loadingPubMedDocs && storedPubMedDocs.length > 0">
                <h4 class="mb-3">{{ 'modals.select-inputs.stored-pubmed' | translate }}</h4>
                <div *ngFor="let doc of storedPubMedDocs"
                     class="input-item"
                     [class.selected]="selectedPubMedIds.has(doc.pmid)"
                     (click)="toggleStoredPubMedSelection(doc.id)">
                  <mat-checkbox [checked]="selectedPubMedIds.has(doc.pmid)" (click)="$event.stopPropagation()"></mat-checkbox>
                  <mat-icon class="mx-2 text-success">article</mat-icon>
                  <div class="flex-grow-1">
                    <div class="input-name">{{ doc.title }}</div>
                    <div class="input-meta">
                      <span *ngIf="doc.authors">{{ doc.authors }}</span>
                      <span class="ml-2" *ngIf="doc.year">{{ doc.year }}</span>
                      <span class="ml-2">PMID: {{ doc.pmid }}</span>
                      <span class="ml-2 text-muted">{{ doc.added_at | date:'dd/MM/yyyy' }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Empty state -->
              <div *ngIf="!loadingPubMedDocs && storedPubMedDocs.length === 0" class="text-center py-4">
                <mat-icon style="font-size: 3rem; color: #ccc;">article</mat-icon>
                <p class="text-muted mt-2">{{ 'modals.select-inputs.no-pubmed-documents' | translate }}</p>
              </div>
            </div>
          </mat-tab>

          <!-- LITERATURE REVIEW TAB -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="mr-2">library_books</mat-icon>
              {{ 'modals.select-inputs.tabs.literature-review' | translate }}
            </ng-template>

            <div class="tab-content p-3">
              <div *ngIf="loadingLiteratureReviews" class="text-center py-4">
                <mat-spinner diameter="40"></mat-spinner>
                <p class="mt-2">{{ 'generic.loading' | translate }}</p>
              </div>

              <div *ngIf="!loadingLiteratureReviews && availableLiteratureReviews.length === 0" class="text-center py-4">
                <mat-icon style="font-size: 3rem; color: #ccc;">library_books</mat-icon>
                <p class="text-muted mt-2">{{ 'modals.select-inputs.no-literature-reviews' | translate }}</p>
              </div>

              <div *ngIf="!loadingLiteratureReviews && availableLiteratureReviews.length > 0">
                <div *ngFor="let review of availableLiteratureReviews"
                     class="input-item"
                     [class.selected]="selectedLiteratureReviews.has(review.id)"
                     (click)="toggleLiteratureReviewSelection(review.id)">
                  <mat-checkbox [checked]="selectedLiteratureReviews.has(review.id)" (click)="$event.stopPropagation()"></mat-checkbox>
                  <mat-icon class="mx-2">library_books</mat-icon>
                  <div class="flex-grow-1">
                    <div class="input-name">{{ review.title }}</div>
                    <div class="input-meta">
                      <span *ngIf="review.documents_count">
                        {{ review.documents_count }} {{ 'modals.select-inputs.documents' | translate }}
                      </span>
                      <span class="badge ml-2" [ngClass]="getQualityBadgeClass(review.overall_quality)" *ngIf="review.overall_quality">
                        {{ review.overall_quality | uppercase }} {{ 'modals.select-inputs.quality' | translate }}
                      </span>
                      <span class="ml-2 text-muted" *ngIf="review.pico_question">
                        <mat-icon class="small-icon">psychology</mat-icon> PICO
                      </span>
                      <span class="ml-2 text-muted">{{ review.updated_at | date:'dd/MM/yyyy' }}</span>
                    </div>
                  </div>
                  <button mat-icon-button (click)="viewRevisionDetails(review.id, $event)" class="ml-2">
                    <mat-icon>visibility</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </mat-tab>

        </mat-tab-group>
      </div>
    </div>

    <!-- Selected Inputs List -->
    <div class="row mt-4" *ngIf="selectedInputs.length > 0">
      <div class="col-12">
        <h3 class="mb-3">{{ 'modals.select-inputs.selected-inputs' | translate }} ({{ selectedInputs.length }})</h3>
        <div class="selected-inputs-list">
          <div *ngFor="let input of selectedInputs; let i = index" class="selected-input-chip">
            <mat-icon [class]="'input-icon-' + input.type">{{ getInputIcon(input.type) }}</mat-icon>
            <span class="input-chip-name">{{ input.name }}</span>
            <span class="input-chip-type">{{ getInputTypeLabel(input.type) }}</span>
            <button mat-icon-button class="remove-btn" (click)="removeInput(i)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="buttons-container container py-5 mb-3">
    <button class="button-primary float-left" mat-button (click)="closeModal()">
      <i class="icon-Backward-arrow-small"></i>
      {{ 'generic.buttons.cancel' | translate }}
    </button>
    <button
      class="button-primary float-right"
      [disabled]="!hasSelections"
      mat-button
      (click)="confirmSelection()">
      <i class="icon-Forward-arrow-small"></i>
      {{ 'modals.select-inputs.confirm-selection' | translate }} ({{ selectedInputs.length }})
    </button>
  </div>
</div>
